import React from 'react';
import ReactDOM from 'react-dom/client';
import "./HamburgerArea.css";
import {Glob as G} from "../libs/Glob.mjs";

const classBaseName = 'HamburgerArea';

const DefaultHamburgerIcon = class extends React.Component {
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" stroke="none" style={this.props.style||{}}>
				<path d="M27,23v2a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1H26A1,1,0,0,1,27,23ZM26,6H6A1,1,0,0,0,5,7V9a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V7A1,1,0,0,0,26,6Zm0,8H6a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V15A1,1,0,0,0,26,14Z"/>
			</svg>
		);
	}
}

const globalCloser = () => {
	G.trigger(classBaseName+'Opens', 'no-menu-id');
	setTimeout( ()=>{
		window.document.querySelectorAll(`body > .${classBaseName}HiWrap`).forEach(n=>{
			const id = n.getAttribute('id');
			const w = window.document.getElementById( id.replace(/-hiwrap$/,'-wrap'));
			if ( ! w ) n.remove();
		});
	});
};

const opener = (id, container, content ) => {
	const doc = window.document;
	const menu = doc.getElementById(id);
	const isEnd = menu.classList.contains('end');
	const box = menu.querySelector(`.${classBaseName}Trigger`).getBoundingClientRect();
	const d = doc.createElement('div');
	d.setAttribute('id', id+'-hiwrap');
	d.addEventListener('mouseleave', ()=>{ G.trigger(classBaseName+'Opens', 'no-menu-id'); });
	d.className = classBaseName+'HiWrap';
	d.style.top = String(box.top + window.scrollY)+'px';
	if ( isEnd ) {
		d.style.right = String(window.document.body.clientWidth - box.right  - window.scrollX)+'px';
	} else {
		d.style.left = String(box.left  + window.scrollX)+'px';
	}
	d.appendChild(menu);
	doc.body.appendChild(d);
	container.render(
		<React.StrictMode>
			{ content }
		</React.StrictMode>
	);
	menu.classList.remove('collapsed');
	menu.classList.add('expanded');
};

const closer = (id) => {
	const doc = window.document;
	const hiwrap = doc.getElementById(id+'-hiwrap');
	if ( ! hiwrap ) return;
	const wrap = doc.getElementById(id+'-wrap');
	const menu = doc.getElementById(id);
	if ( menu ) {
		menu.classList.add('collapsed');
		menu.classList.remove('expanded');
		if ( wrap ) wrap.appendChild(menu);
	}
	hiwrap.remove();
}

/**
 * @typedef {object} HamburgerAreaProps
 * @property {"start"|"center"|"end"} [align] Alignments, defaults to start
 * @property {string|React.Component} [icon] Defaults to SVG hamburger icon
 */

/**
 * Builds the Hamburger Menu and its area
 *
 * @param { Object } props
 * @param  {"start"|"center"|"end"} [props.align] Alignments, defaults to start
 * @param {string| React.Component } [props.icon] Defaults to SVG hamburger icon
 * @return { JSX.Element }
*/
const HamburgerArea = class extends React.Component {
	/**
	 * @param {HamburgerAreaProps} props
	 */
	constructor(props) {
		super(props);
		this.state = {
			align: props.align || 'start',
			icon: props.icon ?? <DefaultHamburgerIcon />,
		};
		this.toggle = this.toggle.bind(this);
		this.uid = G.generateUid(classBaseName);
		const doc = window.document;
		if ( ! doc.body.classList.contains(classBaseName+'Aware') ) {
			doc.body.classList.add(classBaseName+'Aware');
			doc.addEventListener('click', globalCloser );
			G.register('windowResized', ()=>{
				G.trigger(classBaseName+'Opens', 'no-menu-id');
			});
		}
	}
	componentDidMount() {
		G.register(classBaseName+"Opens", id=>{
			if ( id !== this.uid ) this.toggle(false);
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	toggle(mode) {
		if ( typeof mode === "undefined" ) {
			mode = ! this.state.expanded;
		} else if ( mode === !! this.state.expanded ) {
			return;
		}
		const doc = window.document;
		const container = this.state.container ||
			ReactDOM.createRoot(doc.querySelector(`#${this.uid} .${classBaseName}Content`));
		if ( mode ) {
			opener( this.uid, container, this.props.children );
		} else {
			closer( this.uid, container );
		}
		this.setState( { expanded: mode, container:container } );
		G.trigger(classBaseName+(mode ? 'Opens' : 'Closes'), this.uid);
	}
	render() {
		return(
			<div className={classBaseName+"Wrap"} id={this.uid + "-wrap"}>
				<div
					className={`${classBaseName} collapsed ${this.state.align}`}
					id={this.uid}
				>
					<div
						className={classBaseName+"Trigger"}
						onClick={(evt) => {
							evt.stopPropagation();
							this.toggle();
						}}
					>
						{ this.state.icon }
					</div>
					<div className={classBaseName+"Content"} />
				</div>
			</div>
		)
	}
}

export default HamburgerArea;